import React from 'react'
// import Modal from '@material-ui/core/Modal'
import styles from './styles.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton' 
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Dialog from '@material-ui/core/Dialog';
import {connect} from 'react-redux'; 
import SelectComp from '../../utils/Select/SelectComp';
import { addBanner } from '../Banner.api';
import { Formik, Form } from "formik";
import Images from './images/Images';
// import * as Yup from "yup";
// import Images from '../../images/Images';
import ImageUploader from 'react-images-upload';

import { useEffect, useState } from 'react';

const ConfBanner = (props) => {
    const [images, setImages] = React.useState([])
    const [formData,setFormData] = useState({
        id: "",
        images: [],
        type: "Desktop",
        status: "Active",
    }); 
    // Firebase IMAGE function
    // const handleAddImage = (url) => {
    //     let arr = images;
    //     arr.push({imgUrl: url}); 
    //     setImages([...arr]);
    // }

    // const handleDeleteImage = (index) => {
    //     let arr = images;
    //     arr = arr.filter((val,i) => index != i) 
    //     setImages([...arr]);
    // }
 // System Upload IMAGE
    const handleAddImage = (value) => {
        // let url = 'smilekart-api\storage\brand';
        // let name = '';
        let arr = images;
        console.log('add image');
        console.log(value);
        // let arr = images;
        value.map(val => {
            arr.push(val); 
        })
        // arr.push(value);
        setImages([...arr]);
        setFormData({...formData,images:images}); 
        // setImages([...arr]);
    }

    const handleDeleteImage = (index) => {
        let arr = images;
        arr = arr.filter((val, i) => index !== i)
        setImages([...arr]);
    }
    const [loading,setLoading] = useState(false) 
    useEffect(() => {
        if (props.type === "EDIT") { 
            setFormData({...formData,...props.banner,id: props.banner.id})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.banner]); 

    // const SubmitSchema = Yup.object().shape({
    //     question: Yup.string()
    //     .max(50, 'Too Long!')
    //     .required('Required'),
    // });
    // SUBMIT
    const onSubmit = (e) => {
        setLoading(true);
        const type = props.type === "EDIT" ? "EDIT" : "ADD"
        let requestData = new FormData();
        requestData.append("status", formData.status);
        requestData.append("type", formData.type);
        if(images == null || images.length < 1) {
            setLoading(false);
            props.setAlert("Atleast one image required to add Banner");
            return false;
        }
        // requestData.append("images", images);
        for (var i = 0; i < images.length; i++) {
            requestData.append('images['+i+']', images[i]);
        }
        console.log(JSON.stringify(images));
        console.log('req data ');
        console.log(requestData);
        // return false;
        addBanner(type,requestData)
        .then(res => {
            if(res.success) {
                props.onDone()
                setLoading(false);
                props.setAlert("Succesfully Done")
                setImages([]);
                // setFormData({id: "",images: [],status: "Active"})
            } else {
                setLoading(false);
                props.setAlert("Something went wrong !Try Again")
            }
        }).catch(err => {
            console.log(err)
            setLoading(false)
            props.setAlert("Something went wrong !Try Again")
        })
    }

    let btnText = props.type === "EDIT" ? "Update Banner" : "Add Banner";
    return (  
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'sm'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                     <Formik 
                    initialValues={ formData }
                    // validationSchema={SubmitSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        onSubmit(values);
                        setSubmitting(false);
                    }}
                >
              {({ touched, errors, isSubmitting, handleChange }) => (
                <Form >
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>

                    <h2></h2>

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <SelectComp 
                                variant="outlined"
                                className={styles.textField}
                                label="Status"
                                value={formData.status} 
                                onChange={(e) => setFormData({...formData,status: e.target.value})}
                                options={["Active","Inactive"]}
                                values={["Active","Inactive"]}
                            /> 
                        </div>
                        <div className={styles.row}>
                            <SelectComp 
                                variant="outlined"
                                className={styles.textField}
                                label="Type"
                                value={formData.type} 
                                onChange={(e) => setFormData({...formData,type: e.target.value})}
                                options={["Desktop","Mobile"]}
                                values={["Desktop","Mobile"]}
                            />
                        </div>  
                        <h2>Images</h2>
                            {/* <Images 
                                images={images}
                                onAddImage={(url) => handleAddImage(url)}
                                onDeleteImage={(index) => handleDeleteImage(index)}
                            /> */}
                            <ImageUploader
                                withIcon={false}
                                withPreview={true}
                                label=""
                                buttonText="Select and Upload Banner"
                                onChange={handleAddImage}
                                deleteImage={handleDeleteImage}
                                imgExtension={[".jpg", ".jpeg"]}
                                maxFileSize={5242880}
                                fileSizeError=" file size is must be less than 5 mb"
                                />                    
                    </div>
                    <Divider />
                    <div className={styles.footer}>
                        {loading 
                            ?
                        <Button variant="contained" color="secondary">
                            Loading....
                        </Button>
                            :
                        <Button type="submit" variant="contained" color="secondary" disabled={isSubmitting}>
                            {btnText}
                        </Button>}
                    </div>
                </Form>
              )}
            </Formik>
                </div>
            </div>
        </Dialog>  
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user
})
export default connect(mapStateToProps)(ConfBanner);